'use client'

import { Check } from 'lucide-react'

/**
 * The design's 18px checkbox ("Keep me signed in"). Custom-drawn so the 4px
 * radius and brand fill match Figma; the label is the (44px-tall) hit area.
 */
export function CheckboxField({
    id,
    label,
    checked,
    onChange,
}: {
    id: string
    label: string
    checked: boolean
    onChange: (checked: boolean) => void
}) {
    return (
        <label
            htmlFor={id}
            className="-my-3 flex min-h-11 cursor-pointer select-none items-center gap-2 text-sm text-[var(--text-secondary)]"
        >
            <span className="relative flex items-center justify-center">
                <input
                    id={id}
                    type="checkbox"
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    className="peer size-4.5 shrink-0 cursor-pointer appearance-none rounded-sm border-[1.5px] border-[var(--border-strong)] bg-[var(--bg-surface)] checked:border-[var(--border-brand)] checked:bg-[var(--bg-brand)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--border-focus)] focus-visible:ring-offset-2"
                />
                <Check
                    aria-hidden
                    className="pointer-events-none absolute size-3 text-[var(--text-on-brand)] opacity-0 peer-checked:opacity-100"
                    strokeWidth={3}
                />
            </span>
            {label}
        </label>
    )
}
